import { render, staticRenderFns } from "./videoRoom.vue?vue&type=template&id=39df5259&scoped=true"
import script from "./videoRoom.vue?vue&type=script&lang=js"
export * from "./videoRoom.vue?vue&type=script&lang=js"
import style0 from "./videoRoom.vue?vue&type=style&index=0&id=39df5259&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39df5259",
  null
  
)

export default component.exports